import { component as defineComponent } from 'flightjs';

var contestExtensionModal = function () {
    this.attributes({
        extendContest: '[data-contest-extension-pay-button]',
        numberOfDays: '[data-contest-extension-days]',
    });

    this.after('initialize', function () {
        this.on(this.select('extendContest'), 'click', this.triggerExtendContext);
    });

    this.triggerExtendContext = function (event) {
        var select = this.select('numberOfDays');

        this.trigger('hide');
        if (select.val() && select.val().length != 0) {
            this.trigger('uiPaymentModalRequested', {
                paymentsInput: JSON.parse(select.val()),
            });
        }
    };
};

export default defineComponent(contestExtensionModal);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-extension-modal.js